import { AggregationColor } from 'antd/es/color-picker/color';

export const createAggrColorFromGradient = (
  input?: string,
): AggregationColor | null => {
  const stopRegex = /(#[0-9a-fA-F]{3,6}|rgba?\([^)]+\))\s*([0-9.]+)?%?/g;
  const colors =
    input &&
    [...input.matchAll(stopRegex)].map(([, color, percent]) => ({
      color: color.trim(),
      percent: percent ? parseFloat(percent) : 100,
    }));

  return colors ? new AggregationColor(colors) : null;
};

export const getGradientStr = (
  aggregationColor: AggregationColor,
  angle = 90,
): string =>
  aggregationColor
    .toCssString()
    .replace(
      /linear-gradient\(\s*([0-9.]+)deg\s*,/,
      `linear-gradient(${angle}deg,`,
    );
